import React, { useState } from 'react';
import {
    Checkbox,
    Grid,
    TextField,
    FormControlLabel,
    Paper,
    Button,
    CircularProgress
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { useStyles } from '../Shared/FormsStyle';

interface LoginUser {
    userName: string,
    password: string
}

interface LoginProps {
    onSuccess:() => void;
}

const LoginPage = (props: LoginProps) => {
    const classes = useStyles();
    const database = [
        {
            username: "user1",
            password: "pass1"
        },
        {
            username: "user2",
            password: "pass2"
        }
    ];

    const [checked, setChecked] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const[errorMsg, setErrorMsg] = useState({name: '', message:''});

    const validationSchema = Yup.object().shape({
        userName: Yup.string().required('Username is required'),
        password: Yup.string().required('password is required'),
    });

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.name === 'loggedIn') setChecked(event.target.checked);
    };

    const formik = useFormik<LoginUser>({
        initialValues: {
            userName: '',
            password: ''
        },
        validationSchema,
        onSubmit: async (values) => {
            setIsLoading(true);
            console.log("onSubmit -> ", JSON.stringify(values, null, 2))
            const userData = database.find((user) => user.username === values.userName);
            if (userData) {
                if (userData.password !== values.password) {
                  // Invalid password
                  setErrorMsg({name: "password", message: "invalid password"})  
                } else {
                    props.onSuccess();
                }
              } else {
                // Username not found
                setErrorMsg({name: "userName", message: "invalid user"})  
              }
            setIsLoading(false);
        }
    })

    const renderErrorMessage = (name: string) =>
          name === errorMsg.name && (
            <div className={classes.formError}>{errorMsg.message}</div>
        );  

    return (
        <div style={{ padding: 30 }}>
            <Paper>
                <form onSubmit={formik.handleSubmit} >
                    <Grid container spacing={3} direction="column" justifyContent="center" alignItems="center" sx={{ padding: 30 }}>
                        <Grid item xs={12}>
                            <TextField label="Username" name='userName' value={formik.values.userName} onChange={formik.handleChange} ></TextField>
                            {formik.errors.userName && (<div className={classes.formError}>{formik.errors.userName}</div>)}
                            {renderErrorMessage('userName')}
                        </Grid>
                        <Grid item xs={12}>
                            <TextField label="Password" type={'password'} name='password' value={formik.values.password} onChange={formik.handleChange}></TextField>
                            {formik.errors.password && (<div className={classes.formError}>{formik.errors.password}</div>)}
                            {renderErrorMessage('password')}
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel control={<Checkbox name='loggedIn' checked={checked} onChange={handleChange} />} label="Keep me logged in" />
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant='contained' color='primary' type="submit"> Login </Button>     
                            {isLoading && <CircularProgress /> }                      
                        </Grid>
                    </Grid>
                </form>
            </Paper>
        </div>
    );
};

export default LoginPage;
